import PropTypes from 'prop-types';
import {FmlxTooltip, FmlxIcon} from 'fmlx-common-ui';
import {PipettingProfileItemWrapper} from '../PipettingProfileWrapper';
import PipettingProfileInputType from '../PipettingProfileInputType';

function PipettingItemReuseTip({reuseTips, onReuseTipsChange, toolTipTitle}) {
  return (
    <PipettingProfileItemWrapper>
      <span>
        Reuse tip &nbsp;
        <FmlxTooltip title={toolTipTitle}>
          <span style={{position: 'absolute'}}>
            <FmlxIcon name="Info" size="xs" customColor="#414141" />
          </span>
        </FmlxTooltip>
      </span>
      <PipettingProfileInputType.Switch onChange={onReuseTipsChange} checked={reuseTips} />
    </PipettingProfileItemWrapper>
  );
}

PipettingItemReuseTip.propTypes = {
  toolTipTitle: PropTypes.string.isRequired,
  reuseTips: PropTypes.bool.isRequired,
  onReuseTipsChange: PropTypes.func.isRequired,
};

export default PipettingItemReuseTip;
